/**
*
* AnalyticsAndGdpr
*
*/

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Modal, Button, Group, Container
} from '@mantine/core';

import { cookieSet } from '../../utils/cookies';
import googleAnalyticsWrapper from '../../utils/googleAnalyticsWrapper';
import * as classes from './AnalyticsAndGdpr.module.css';


// FIXME: dare un nome più descrittivo al componente, visto che non è solo il banner
// dei cookie ma registra pure le analytics
function AnalyticsAndGdpr({
  locationPathname,
  setGDPRChoicesFunction,
  pageTitle,
  userSettings: { gdprPreferencesEnabled, gdprAnalyticsEnabled }
}) {
  // trick-porcheria per aggirare l'hydration di gatsby
  // e forzare l'aggiornamento del contenuto del wrapper cookie sul front-end
  // https://github.com/gatsbyjs/gatsby/issues/14601#issuecomment-499922794
  const [isClient, setClient] = useState(false);

  useEffect(() => {
    if (gdprAnalyticsEnabled) {
      googleAnalyticsWrapper('send', {
        hitType: 'pageview',
        path: locationPathname,
        title: pageTitle,
      });
    }
  }, [gdprAnalyticsEnabled, locationPathname, pageTitle]);

  useEffect(() => {
    setClient(true);
  }, []);

  return (
    <Modal
      opened={isClient && process.env.GATSBY_UA_ANALYTICS && !gdprPreferencesEnabled}
      size="auto"
      title="Informativa sui cookie"
      key={isClient ? 'client' : 'server'}
      withCloseButton={false}
      closeOnClickOutside={false}
      closeOnEscape={false}
      withOverlay
    >
      <Container>
        <p>
          Al fine di offrire il miglior servizio possibile questo sito utilizza cookies tecnici e di terze parti per funzionalità quali l&apos;accesso tramite social network e/o la visualizzazione di media. Se non acconsenti all&apos;utilizzo dei cookie di terze parti, alcune di queste funzionalità potrebbero essere non disponibili. Chiudendo questo banner o proseguendo con la navigazione acconsentirai al loro impiego. Per saperne di pi&ugrave; o negare il consenso a tutti o ad alcuni cookie puoi consultare <a href="https://maieuticallabs.it/privacy" rel="noopener noreferrer" target="_blank"><span>l&apos;informativa sulla privacy</span></a>.
        </p>
        <div>
          <Group justify="center" className={classes.buttongroup} mt="xl">
            <Button
              variant="outline"
              onClick={() => {
                cookieSet({ cookieKey: 'gdpr_preferences_set', payload: 'true' });
                cookieSet({ cookieKey: 'gdpr_analytics_on', payload: 'false' });
                setGDPRChoicesFunction({
                  gdprPreferencesEnabled: true, gdprAnalyticsEnabled: false
                });
              }}
            >
              Accetta solo essenziali
            </Button>
            <Button
              onClick={() => {
                cookieSet({ cookieKey: 'gdpr_preferences_set', payload: 'true' });
                cookieSet({ cookieKey: 'gdpr_analytics_on', payload: 'true' });
                setGDPRChoicesFunction({
                  gdprPreferencesEnabled: true, gdprAnalyticsEnabled: true
                });
              }}
            >
              Accetta tutti
            </Button>
          </Group>
        </div>
      </Container>
    </Modal>
  );
}

AnalyticsAndGdpr.propTypes = {
  locationPathname: PropTypes.string,
  pageTitle: PropTypes.string,
  userSettings: PropTypes.object,
  setGDPRChoicesFunction: PropTypes.func,
};


export default AnalyticsAndGdpr;
